import { render, staticRenderFns } from "./BtnSettings.vue?vue&type=template&id=17933bc5&"
import script from "./BtnSettings.vue?vue&type=script&lang=js&"
export * from "./BtnSettings.vue?vue&type=script&lang=js&"
import style0 from "./BtnSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports